import React,{useState, useEffect, useRef} from "react";
import { Link, useNavigate } from 'react-router-dom'
import axios from "axios";
import { userurl } from '../../apis/urls'
import { $ } from "react-jquery-plugin";

const ForgotPassword = () => {

    document.body.classList.remove("new-login-wrpr");
    useEffect( ()=>{
        $('body').removeClass('').addClass('sidebar-collapsed');
        $('.sidebar-toggler').removeClass('sidebar-toggler').addClass('sidebar-toggler-remove');
    },[])

    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [emailerror,setEmailError] = useState(false);
    const [usererror,setUserError] = useState(false);

    let userisrule = localStorage.getItem('userisrule');
    let forgotpasswordcoach = localStorage.getItem('forgotpasswordcoach');


    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/")
        
    }



    const onClickFrom =()=> {

        let error = 0;

		if(email === '')
		{
			setEmailError(true)
			error =1;
		}
		else
		{
			setEmailError(false)
		}



        if(error === 0)
        {
            let token = "Bearer "+localStorage.getItem('token');

            const data = {
                user:email
            }

            const instance = axios.create({

                baseURL: userurl+"/forgotpassword",

                timeout: 1000000,

                // headers: {'authorization': token}

            });

            instance.put('',data).then((response) =>{

                
                const role = response.data.data.role;
               
                alert("Your password has been sent to your Email , you can login with the username and password")
                if(role === "ASSOCIATION_USER")
                {
                    window.open('https://giaasports.org/','_self');
                }
                else if(role === "OFFICIALS_USER")
                {
                    navigate("/coaches")
                }
                else if(userisrule == '1')
                {
                    if(forgotpasswordcoach == '1')
                    {
                        navigate("/coaches")
                        localStorage.removeItem('forgotpasswordcoach');
                    }
                    else
                    {
                        navigate("/")
                    }
                   
                }
                else if(forgotpasswordcoach == '1')
                {
                    navigate("/coaches")
                    localStorage.removeItem('forgotpasswordcoach');
                }
                else 
                {
                    navigate("/")
                }
                

            }).catch((error) =>{
                console.log('error',error.response.data.error[0].user)

                if(error.response.data.error[0].user === 'User not found')
                {
                    setUserError(true)

                }
               

            });;

        }
    }

    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area no-header">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Forgot Password</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>

                    <form className="needs-validation">
                        <div className="form-wrpr">
                            <div className="card formcard medium">
                                <div className="card-body">

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Email<span style={{color: "red"}}>*</span></label>
                                            <input type="text" value={email} onChange={e => {setEmail(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter the Email" />
                                            {
                                                emailerror
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter the Email</div>:null
                                            }
                                            {
                                                usererror
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>User not found</div>:null
                                            }
                                        </div>
                                       
                                    </div>
                                </div>

                                <div className="form-group text-right ">
                                    <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                    <button className="btn btn-primary btn-gisa" onClick={ onClickFrom } type="button">Submit </button>
                                </div>



                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </aside>
        </div>

    )
}

export default ForgotPassword;